import { useEffect } from "react";
import { useRegistrationForm } from "../provider/registrationFormProviderContext";
import { RenderRegistrationBlock } from "../RenderRegistrationBlock";

export const RegistrationWaitingListPage = () => {
	const { registrationForm, clearRegistration } = useRegistrationForm();

	useEffect(() => {
		clearRegistration();
	}, [clearRegistration]);

	return <RenderRegistrationBlock blockId={registrationForm.waitingListConfirmationBlockId} />;
};
